const routes = {
  createState: 'state',
  getStates: 'state',
  getStateById: 'state/',
  updateState: 'state/',
  deleteState: 'state/',
  getInfoByZipCode: 'state/get-info-by-zip/',
};

export default routes